// @flow
import { createSelector } from 'reselect'
import { Map, List } from 'immutable';

export const getTagMap = (mitreAttackThreatModel: Map<string,any>) => {
  return mitreAttackThreatModel.get('items', List())
    .reduce((acc, curr, i) => {
      return acc.set(curr.get('key'), curr);
    }, Map());
};


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/contexts/mitre-attack/getters.js